<style scoped lang="scss">

</style>

<template>
    <div class="uk-width-1-1 uk-grid">

        <header-row/>

        <div class="uk-width-1-1 uk-margin-bottom">
            <h2>Applicant Data:</h2>

            <h3>COVID 19 Hardship:</h3>
            <p>{{ applicant.need_for_assistance }}</p>
        </div>

        <div class="uk-width-1-3">
            <div>Applicant: {{ applicant.first_name }} {{ applicant.last_name }}</div>
            <div>Phone: {{ applicant.primary_contact.formatted_number }}</div>
            <div>SSN: {{ applicant.ssn | last4 }}</div>
        </div>
        <div class="uk-width-1-3">
            <div>&nbsp;</div>
            <div>Email: {{ application.user.email }}</div>
            <div>Birthday: {{ applicant.dob | moment('MM/DD/YYYY') }}</div>
        </div>
        <div class="uk-width-1-3">
            <div>Household ID: {{ application.household.id }}</div>
            <div>Household Member ID: {{ headOfHousehold.id }}</div>
        </div>

        <div class="uk-width-1-1 uk-margin-bottom uk-margin-top" v-if="application.household && application.household.members.length > 1">
            <h3>Household Members:</h3>
        </div>

        <div class="uk-width-1-1">
            <div class="uk-grid" v-for="member in application.household.members" v-if="member.id != headOfHousehold.id">
                <div class="uk-width-1-3">
                    <div>Household Member ID: {{ member.id }}</div>
                    <div>Member: {{ member.first_name }} {{ member.last_name }}</div>
                    <div>SSN: {{ member.ssn | last4 }}</div>
                </div>
                <div class="uk-width-1-3">
                    <div>
                        <span v-if="assets.hhRelations[member.household_relationship_id]">{{ assets.hhRelations[member.household_relationship_id].household_relationship_desc }}</span>
                    </div>
                    <div>Birthday: {{ member.birth_date | moment('MM/DD/YYYY') }}</div>
                </div>
                <div class="uk-width-1-3">
                    <div>&nbsp;</div>
                    <div>Age: {{ member.age }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import HeaderRow from "./HeaderRow";

    export default {
        name: "ApplicantData",
        components: {HeaderRow},
        computed: {
            ...mapState('Application', {
                assets: 'assets',
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                documentRequests: 'documentRequests',
                documents: 'documents',
                renterManager: 'renterManager',
                landlordConfirmations: 'landlordConfirmations',
            }),
            ...mapGetters('Application', {
                headOfHousehold: 'headOfHousehold'
            })
        },
        filters: {
            last4(value) {
                if(!value) {
                    return "";
                }

                if(value === undefined) {
                    return "";
                }

                return 'XXX-XX-'+value.substr(value.length-4, 4);
            },
        },
        methods: {

        }
    }
</script>
